// Contact.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './LegalPages.css';
import logo from '../images/logo.png';

function Contact() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        customSubject: '',
        message: ''
    });
    const [submitted, setSubmitted] = useState(false);
    const [showCustomSubject, setShowCustomSubject] = useState(false);

    const user = JSON.parse(localStorage.getItem('user'));
    const user_id = user?.user_id;

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    const handleSubjectChange = (e) => {
        const value = e.target.value;
        setFormData({
            ...formData,
            subject: value
        });
        setShowCustomSubject(value === 'other');
        if (value !== 'other') {
            setFormData(prev => ({ ...prev, customSubject: '' }));
        }
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch('https://koru-ai-eight.vercel.app/contact' || 'https://koru-ai.onrender.com/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            setSubmitted(true);

            setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
            });

            setShowCustomSubject(false);
            setTimeout(() => setSubmitted(false), 5000);

        } catch (error) {
            setError('Network error. Please check your connection and try again.');

        } finally {
            setLoading(false);
        }
    };

    const contactMethods = [
        {
            icon: "bi-envelope",
            title: "Email Us",
            value: "c84289798@gmail.com",
            link: "mailto:c84289798@gmail.com",
            description: "We'll respond within 24 hours"
        },
        {
            icon: "bi-github",
            title: "GitHub",
            value: "Marshall AI",
            link: "https://github.com/rajput81325",
            description: "Check out our open source projects"
        },
        {
            icon: "bi-linkedin",
            title: "LinkedIn",
            value: "Marshall AI",
            link: "https://www.linkedin.com/in/aman-rajput-2b7680316/",
            description: "Connect with us professionally"
        }
    ];

    const faqs = [
        {
            question: "What is the response time?",
            answer: "We typically respond to all inquiries within 24-48 hours."
        },
        {
            question: "Do you offer enterprise support?",
            answer: "Yes, we offer dedicated support for enterprise customers. Please mention 'Enterprise' in your message."
        },
        {
            question: "Can I report a bug?",
            answer: "Absolutely! Please use the contact form and select 'Bug Report' as the subject."
        }
    ];

    const subjectOptions = [
        { value: "", label: "Select a subject" },
        { value: "general", label: "General Inquiry" },
        { value: "support", label: "Technical Support" },
        { value: "feedback", label: "Feedback" },
        { value: "bug", label: "Bug Report" },
        { value: "business", label: "Business Inquiry" },
        { value: "feature", label: "Feature Request" },
        { value: "other", label: "Other" }
    ];

    return (
        <div className="legal-page light-theme">
            <style>
                {`
                    /* Custom Select Styling */
                    .custom-select-wrapper {
                        position: relative;
                        width: 100%;
                    }
                    
                    .custom-select {
                        width: 100%;
                        padding: 0.9rem 1rem;
                        font-size: 1rem;
                        color: #1a1a1a;
                        background-color: #ffffff;
                        border: 1.5px solid #e0e0e0;
                        border-radius: 10px;
                        appearance: none;
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        font-weight: 400;
                        line-height: 1.5;
                    }
                    
                    .custom-select:hover {
                        border-color: #4361ee;
                        background-color: #f8f9ff;
                    }
                    
                    .custom-select:focus {
                        outline: none;
                        border-color: #4361ee;
                        box-shadow: 0 0 0 4px rgba(67, 97, 238, 0.1);
                        background-color: #ffffff;
                    }
                    
                    .custom-select option {
                        padding: 12px;
                        background: white;
                        color: #1a1a1a;
                        font-size: 1rem;
                    }
                    
                    .custom-select option:hover {
                        background: #4361ee;
                        color: white;
                    }
                    
                    .select-arrow {
                        position: absolute;
                        right: 1rem;
                        top: 50%;
                        transform: translateY(-50%);
                        color: #4361ee;
                        pointer-events: none;
                        font-size: 1.2rem;
                        transition: transform 0.3s ease;
                    }
                    
                    .custom-select:focus + .select-arrow {
                        transform: translateY(-50%) rotate(180deg);
                    }
                    
                    /* Custom Subject Input */
                    .custom-subject-input {
                        margin-top: 1rem;
                        animation: slideDown 0.3s ease;
                    }
                    
                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            transform: translateY(-10px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                    
                    .custom-subject-input input {
                        width: 100%;
                        padding: 0.9rem 1rem;
                        font-size: 1rem;
                        border: 1.5px solid #e0e0e0;
                        border-radius: 10px;
                        transition: all 0.3s ease;
                        background: #ffffff;
                    }
                    
                    .custom-subject-input input:focus {
                        outline: none;
                        border-color: #4361ee;
                        box-shadow: 0 0 0 4px rgba(67, 97, 238, 0.1);
                    }
                    
                    .custom-subject-input input::placeholder {
                        color: #999;
                        font-size: 0.95rem;
                    }
                    
                    /* Error Message */
                    .error-message {
                        padding: 1rem 1.25rem;
                        background: #fee2e2;
                        border: 1px solid #fecaca;
                        border-radius: 10px;
                        color: #dc2626;
                        margin-bottom: 1.5rem;
                        display: flex;
                        align-items: center;
                        gap: 0.75rem;
                        animation: shake 0.5s ease;
                    }
                    
                    @keyframes shake {
                        0%, 100% { transform: translateX(0); }
                        25% { transform: translateX(-5px); }
                        75% { transform: translateX(5px); }
                    }
                    
                    .error-message i {
                        font-size: 1.25rem;
                        flex-shrink: 0;
                    }
                    
                    /* Submit Button */
                    .submit-btn {
                        width: 100%;
                        padding: 1rem 2rem;
                        color: white;
                        border: none;
                        border-radius: 12px;
                        font-size: 1.1rem;
                        font-weight: 600;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 0.75rem;
                        box-shadow: 0 4px 15px rgba(67, 97, 238, 0.3);
                        margin-top: 1.5rem;
                    }
                    
                    .submit-btn:hover:not(:disabled) {
                        box-shadow: 0 8px 25px rgba(67, 97, 238, 0.4);
                    }
                    
                    .submit-btn:active:not(:disabled) {
                        box-shadow: 0 4px 15px rgba(67, 97, 238, 0.3);
                    }
                    
                    .submit-btn:disabled {
                        opacity: 0.7;
                        cursor: not-allowed;
                        transform: none;
                        box-shadow: 0 2px 8px rgba(67, 97, 238, 0.2);
                    }
                    
                    .submit-btn .spinner-border {
                        width: 1.25rem;
                        height: 1.25rem;
                        border-width: 0.15em;
                    }
                    
                    /* Form Inputs */
                    .form-group input,
                    .form-group textarea {
                        width: 100%;
                        padding: 0.9rem 1rem;
                        font-size: 1rem;
                        border: 1.5px solid #e0e0e0;
                        border-radius: 10px;
                        transition: all 0.3s ease;
                        background: #ffffff;
                        font-family: inherit;
                    }
                    
                    .form-group input:hover,
                    .form-group textarea:hover {
                        border-color: #4361ee;
                        background-color: #f8f9ff;
                    }
                    
                    .form-group input:focus,
                    .form-group textarea:focus {
                        outline: none;
                        border-color: #4361ee;
                        box-shadow: 0 0 0 4px rgba(67, 97, 238, 0.1);
                        background-color: #ffffff;
                    }
                    
                    .form-group input::placeholder,
                    .form-group textarea::placeholder {
                        color: #999;
                        font-size: 0.95rem;
                    }
                    
                    .form-group label {
                        display: block;
                        margin-bottom: 0.5rem;
                        font-weight: 600;
                        color: #1a1a1a;
                        font-size: 0.95rem;
                    }
                    
                    .form-group label .required {
                        color: #dc2626;
                        margin-left: 2px;
                    }
                    
                    /* Character count */
                    .char-count {
                        text-align: right;
                        font-size: 0.8rem;
                        color: #999;
                        margin-top: 0.25rem;
                    }
                    
                    .char-count.warning {
                        color: #f59e0b;
                    }
                    
                    .char-count.danger {
                        color: #dc2626;
                    }
                `}
            </style>

            {/* Navigation */}
            <nav className="legal-navbar">
                <div className="legal-nav-container">
                    <button
                        className="legal-brand"
                        onClick={() => navigate(user_id ? '/home' : '/')}
                    >
                        <img src={logo} alt='Marshall AI Logo' className='legal-logo' />
                        <span>Marshall AI</span>
                    </button>
                    <button
                        className="legal-back-btn"
                        onClick={() => navigate(-1)}
                    >
                        <i className="bi bi-arrow-left me-2"></i>
                        Back
                    </button>
                </div>
            </nav>

            {/* Main Content */}
            <div className="legal-container">
                <div className="legal-content">
                    <h1 className="legal-title">Contact Us</h1>
                    <p className="legal-last-updated">We'd love to hear from you</p>

                    {/* Contact Methods Grid */}
                    <section className="legal-section">
                        <h2>Ways to Connect</h2>
                        <div className="contact-methods-grid">
                            {contactMethods.map((method, index) => (
                                <a
                                    key={index}
                                    href={method.link}
                                    target={method.link.startsWith('http') ? '_blank' : undefined}
                                    rel="noopener noreferrer"
                                    className="contact-method-card"
                                >
                                    <i className={`bi ${method.icon} contact-method-icon`}></i>
                                    <h3>{method.title}</h3>
                                    <p className="contact-method-value">{method.value}</p>
                                    <p className="contact-method-desc">{method.description}</p>
                                </a>
                            ))}
                        </div>
                    </section>

                    {/* Contact Form */}
                    <section className="legal-section">
                        <h2>Send Us a Message</h2>

                        {submitted ? (
                            <div className="success-message">
                                <i className="bi bi-check-circle-fill"></i>
                                <h3>Thank You!</h3>
                                <p>Your message has been sent successfully. We'll get back to you soon.</p>
                            </div>
                        ) : (
                            <form className="contact-form" onSubmit={handleSubmit}>
                                {error && (
                                    <div className="error-message">
                                        <i className="bi bi-exclamation-triangle-fill"></i>
                                        <span>{error}</span>
                                    </div>
                                )}

                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="name">
                                            Full Name <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder="John Doe"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email">
                                            Email Address <span className="required">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="john@example.com"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="subject">
                                        Subject <span className="required">*</span>
                                    </label>
                                    <div className="custom-select-wrapper">
                                        <select
                                            id="subject"
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleSubjectChange}
                                            className="custom-select"
                                            required
                                        >
                                            {subjectOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                        <i className="bi bi-chevron-down select-arrow"></i>
                                    </div>

                                    {showCustomSubject && (
                                        <div className="custom-subject-input">
                                            <input
                                                type="text"
                                                name="customSubject"
                                                value={formData.customSubject}
                                                onChange={handleChange}
                                                placeholder="Enter your subject..."
                                                autoFocus
                                            />
                                        </div>
                                    )}
                                </div>

                                <div className="form-group">
                                    <label htmlFor="message">
                                        Message <span className="required">*</span>
                                    </label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        className='text-black'
                                        onChange={handleChange}
                                        placeholder="Tell us how we can help..."
                                        rows="6"
                                        required
                                    ></textarea>
                                    <div className={`char-count ${formData.message.length > 500 ? 'warning' : ''} ${formData.message.length > 1000 ? 'danger' : ''}`}>
                                        {formData.message.length} characters
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    className="submit-btn"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            <span>Sending Message...</span>
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-send-fill"></i>
                                            <span>Send Message</span>
                                        </>
                                    )}
                                </button>

                                <p style={{
                                    textAlign: 'center',
                                    marginTop: '1rem',
                                    fontSize: '0.85rem',
                                    color: '#999'
                                }}>
                                    <i className="bi bi-shield-check me-1"></i>
                                    Your information is secure and will never be shared.
                                </p>
                            </form>
                        )}
                    </section>

                    {/* FAQ Section */}
                    <section className="legal-section">
                        <h2>Frequently Asked Questions</h2>
                        <div className="faq-list">
                            {faqs.map((faq, index) => (
                                <div key={index} className="faq-item">
                                    <h3>
                                        <i className="bi bi-question-circle me-2"></i>
                                        {faq.question}
                                    </h3>
                                    <p>{faq.answer}</p>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Office Hours */}
                    <section className="legal-section">
                        <h2>Support Hours</h2>
                        <div className="hours-grid">
                            <div className="hour-item">
                                <i className="bi bi-calendar-check"></i>
                                <span>Monday - Friday</span>
                                <strong>9:00 AM - 6:00 PM (IST)</strong>
                            </div>
                            <div className="hour-item">
                                <i className="bi bi-calendar"></i>
                                <span>Saturday</span>
                                <strong>10:00 AM - 4:00 PM (IST)</strong>
                            </div>
                            <div className="hour-item">
                                <i className="bi bi-calendar-x"></i>
                                <span>Sunday</span>
                                <strong>Closed</strong>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default Contact;